import { IDevice } from "../../../../interfaces/businessFull.interface";
import { LocalDateAsUTC } from "../../../../utils/LocalDateAsUTC";

export const ACTIVE_WINDOW_MINUTES = 30;

const lastOnlineTime = (device?: IDevice) => {
  if (!device?.lastOnline) return 0;
  const time = new LocalDateAsUTC(device.lastOnline).time;
  return Number.isNaN(time) ? 0 : time;
};

const activeCutoff = () =>
  new LocalDateAsUTC().subtractMinutes(ACTIVE_WINDOW_MINUTES).time;

export const isDeviceActive = (device?: IDevice) =>
  lastOnlineTime(device) > activeCutoff();

export const sortDevicesByLastOnline = (devices: IDevice[]): IDevice[] => {
  const cutoff = activeCutoff();

  return devices
    .map((device) => {
      const time = lastOnlineTime(device);
      return { device, active: time > cutoff, time };
    })
    .sort((a, b) =>
      a.active !== b.active ? (a.active ? -1 : 1) : b.time - a.time
    )
    .map((entry) => entry.device);
};
